// modules
import React from 'react';
import { Text, View } from '@upstox/upstox-ui';
// services
import Format from 'modules/Format';
import LocaleService from 'modules/Localization';
// store
import { useStore } from 'modules/Stores';

const DeletePriceAlert: React.FC = () => {
  const { toDeleteAlertId, priceAlertList } = useStore('PriceAlertsStore');
  const alert = priceAlertList
    .find(alertItem => alertItem.id === toDeleteAlertId);

  const getRuleText = () => {
    const rules = alert?.rules;
    if (!rules || rules.length === 0) {
      return '';
    }

    // iterate over rules and return the rule by and
    const toReturn = rules.map((rule, index) => (
      <Text
        size="m"
        family="tvFont"
        key={rule.value}
      >
        {` price ${rule.type === 'ABOVE' ? LocaleService.translate('ABOVE') : LocaleService.translate('BELOW')} `}
        <Text size="m" family="tvFont" weight="bold">
          {Format.formatIndianPrice(rule.value)}
        </Text> {index < rules.length - 1 ? LocaleService.translate('AND') : LocaleService.translate('QUESTION_SIGN')}
      </Text>
      ),
    );

    return toReturn;
  };

  return (
    <View padding="medium">
      <Text size="m" family="tvFont">
        {LocaleService.translate('DELETE_ALERT_BANNER')}
        <Text size="m" family="tvFont" weight="bold">
          {' '}{alert?.instrument.s || alert?.instrument.t}
        </Text>
        {getRuleText()}
      </Text>
    </View>
  );
};

export default DeletePriceAlert;
